<template>
  <div class="footer">
    <div class="container text-center">
      <h3>{{ homeInfo.blogTitle }}</h3>
      <p><i>{{ homeInfo.blogIntroduction }}</i></p>
<!--      <p v-if="curYear === config.blogStartYear">-->
<!--        &copy; {{ curYear }} {{ config.name }}.&nbsp;-->
<!--        Powered by <a href="https://gitee.com/DuanQingStudy" target="_blank">VueBlogger</a>.-->
<!--      </p>-->
<!--      <p v-else>-->
<!--        &copy; {{ homeInfo.startYear }} - {{ homeInfo.currentYear }} {{ homeInfo.userName }}.&nbsp;-->
<!--        Powered by <a href="https://gitee.com/DuanQingStudy" target="_blank">VueBlogger</a>.-->
<!--      </p>-->
      <p>Copyright © 2022-2024 https://gitee.com/DuanQingStudy. All Rights Reserved. duanqing 版权所有</p>
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号: </a>
      <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2024043300号</a>
      <p style="font-size: 10px">建议您使用Chrome、Firefox、Edge、IE10及以上版本和360等主流浏览器浏览本网站</p>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'Footer',
  data: function () {
    return {
      config: this.getConfig().config,
      curYear: new Date().getFullYear(),
      homeInfo: {}
    }
  },
  mounted () {
    if (Cookies.get('homeInfo') !== null && Cookies.get('homeInfo') !== undefined) {
      this.homeInfo = JSON.parse(Cookies.get('homeInfo'))
    }
  },
  methods: {
    getYear: function () {
      return new Date().getFullYear()
    }
  }
}
</script>
